module.exports = __webpack_public_path__ + "img/Logo.13c5b1c0.svg";